var separator = "@@",
transform_answer = {
    nonspace:'nospace'
},
month_names = ['January', 'Febuary', 'March', 'April','may', 'June', 'July','August', 'September', 'October', 'November', 'December'],
day_names = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
month_31 = ['January', 'March', 'May','july', 'August', 'October', 'December'],
month_30 = ['April', 'June', 'September', 'November',],
actual_date = new Date(),
day = actual_date.getDay(),
lbl = {
    result: 'result',
    multi: n => ('multi' + (n || '')),
    add: n => 'add' + (n || ''),
    sous: n => 'sous' + (n || ''),
    div: n => 'div' + (n || ''),
    lbl: lbl => lbl,
},
operator = {
    add: '+',
    sous: '-',
    div: '/',
    multi: 'x',
    gcf: '>',
    lcm: '<',
    fract: 'fract',
    rsd: 'fract-rsd',
    fad: 'fad',
},
operand = {
    multi: n => '__op:multi' + (n || '') + '__',
    add: n => '__op:add' + (n || '') + '__',
    sous: n => '__op:sous' + (n || '') + '__',
    div: n => '__op:div' + (n || '') + '__',
    number: n => '__number' + (n || '') + '__',
    const: n => '__const' + (n || '') + '__',
    op: lbl => '__op:' + lbl + '__',
    var: v => '__' + v + '__',
    float: f => '__float' + f + '__',
    result: '__result__',
},
types_answer_tab = [
    {title: 'int', desc: "Only accept Whole numbers", value: "int"},
    {title: 'text', desc: "Accept text as answer", value: "text"},
    {title: 'decimal', desc: 'allow to give float number as answer', value: "float"},
    {title: 'fraction', desc: 'change field to fraction type', value: "fract"},
    {title: 'radio', desc: 'Change input field to MCQ', value: "radio"},
],
transforms_anwer_tab = [
    {value: 'nospace', desc: 'Evaluating answer without consider spaces as part of answer', title: "no space", except: []},
    {value: 'mono-space', desc: 'Evaluating answer and consider one space between words', title: "mono space", only: ['text']},
    {value: 'simplificated', desc: 'Answer given must be a fraction simplificated', title: 'simplificated', only: ['fraction']},
]
;
// console.log("csrf-token:",token);
Array.prototype.sort_lt = function() {
    return this.sort((a,b) => a - b);
    };
Array.prototype.sort_gt = function() {
    return this.sort((a,b) => b - a);
    };
Array.prototype.sort_rn = function() {
    return this.sort(() => Math.random() - 0.5);
    };
Array.prototype.getRand = function() {
    return this[rn(0,this.length - 1)];
    };
Array.prototype.getLast = function() {
    return this[this.length - 1];
    };
Array.prototype.replaceVals = function(old, newVal) {
    return this.join(separator).toString().replace(new RegExp(old, "g"),newVal).split(separator);
    };
Array.prototype.filterInt = function() {
    return this.filter(Number).map(el => parseInt(el));
    };
Array.prototype.filterFloat = function() {
    return this.filter(Number).map(el => parseFloat(el));
    };
Array.prototype.chunk = function(size){
    const chunked_arr = [];
    let index = 0;
    while (index < this.length) {
        chunked_arr.push(this.slice(index, size + index));
        index += size;
    }
    return chunked_arr;
    };
Array.prototype.distinct = function() {
    return Array.from(new Set(this));
    };
Array.prototype.groupBy = function(field, children_label = 'children', options = {}) {
    let arr = {},item,j=0;
    for (let item of this) {
        let key = item.hasOwnProperty(field) && item[field] != undefined ? item[field] : 'non-grouped';
        if(arr[key] === undefined){
            arr[key] = {};
            if (options.hasOwnProperty('groupPropsIncluded')) {
                arr[key] = Object.assign({}, item[options.groupPropsIncluded])
            }
            arr[key][field] = key;
            arr[key][children_label] = [item];
        }else{
            arr[key][children_label].push(item);
        }
    }
    return Object.values(arr);
    };
Array.prototype.uniqueElementsBy = function(fn) {
    return this.reduce((acc, v) => {
        if (!acc.some(x => fn(v, x))) acc.push(v);
        return acc;
    }, []);
    };
Array.prototype.max = function() {
    return Math.max(...this);
    };
Array.prototype.min = function() {
    return Math.min.apply(null, this);
    };
Array.prototype.estimated = function () {
    let l=this.map(el=>el.toString().length).filter(el=>el>1).min()-1, pow=Math.pow(10,l);
    return this.map(el=>el>9?(el/pow).toFixed(0)*pow:el);
    }
Number.prototype.getLength = function() {
    return this.toString().length;
    };
Number.prototype.getDigit = function(n) {
    return parseInt(this.toString().charAt(n));
    };
Number.prototype.isPrime = function() {
    for(let i = 2, s = Math.sqrt(this); i <= s; i++)
        if(this % i === 0) return false;
    return this > 1;
    };
Number.prototype.__defineGetter__('length',function(){return this.toString().length;});
Number.prototype.__defineGetter__('k_notation', function() {
    if(this<100)
        return this;
    if(this<1000)
        return '0,' + this.getDigit(0) + 'k';
    if(this<100000)
        return parseInt(this/1000) + ((this%1000===0?'': ',' +this.getDigit(1))) + 'k';
    if(this<1000000)
        return '0,' + this.getDigit(0) + 'M';
    if(this<100000000)
        return parseInt(this/1000000) + ((this%1000000===0?'': ',' +this.getDigit(1))) + 'M';
    if(this<1000000000)
        return '0,' + this.getDigit(0) + 'Md';
    return this/1000000000 + ((this%1000000000===0?'':',' +this.getDigit(1))) + 'Md';
    });
Date.prototype.__defineGetter__('month_name',function(){return month_names[this.getMonth()]});
Date.prototype.__defineGetter__('day_name',function(){return day_names[this.getDay()]});
Date.prototype.__defineGetter__('year_number_days',function(){return this.getFullYear()%4==0?'366':'365'});
Date.prototype.__defineGetter__('month_number_days',function(){
    // console.log("getting month_number_days",this);
    let mon=this.month_name, year=this.getFullYear();
    return month_31.includes(mon)?31:month_30.includes(mon)?30:year%4==0?29:28;
    });
Date.prototype.add_years=function(n){
    let date=new Date(this);
    // console.log("add_years: adding ",n," years, this: ",this);
    date=new Date(date.setFullYear(date.getFullYear()+n));
    return date;
    }
Number.prototype.decompose = function() {
    if(this.isPrime()){
        return {p:1,num:this};
    }
    let arr = [], n = this,p;
    for(let i = 2; i < this; i++){
        if(i.isPrime()){
            p = 0;
            for(let j = 1; n % i == 0; j++){
                n = n / i;
                p++;
            }
            if(p > 0){
                arr.push({ p: p, num: i });
            }
        }
    }
    // console.log("decompose ",this,arr);
    return arr;
    };
Number.prototype.D_P = function() {
    if(parseInt(this) == this)
        return '';
    return this.toString().split('.')[1];
    };
Date.prototype.add_months = function(n){
    return new Date(d.setMonth(this.getMonth() + n));
    };


function copy_arr(arg){
    if (!arg) {
        return arg;
    }

    let v;
    let obj = Array.isArray(arg) ? [] : {};
    for (const k in arg) {
        v = arg[k];
        obj[k] = (typeof v === "object") ? copy_arr(v) : v;
    }

    return obj;
    // return JSON.parse(JSON.stringify(arg));
    }
function loadArgs($arguments){
    return Array.from($arguments).flat();
    }
function loadArgNumbers($args){
    let args = loadArgs($args).flat(2), float = false;
    for(let i = 0; i < args.length; i++){
        float = float || parseFloat(args[i]) != parseInt(args[i])
    }
    args = float ? args.filterFloat() : args.filterInt();
    // console.log("loadArgNumbers: float->",float,args);
    return args;
    }
function addDaysToDate (date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d.toISOString().split('T')[0];
    }
function alt(){
    let val;
    for (let i = 0, l = arguments.length; i < l; i++) {
        val = arguments[i];
        if (val != null && !isNaN(val) && val!=='') //check only for null & undefined, you can also do if (val != null) which will check for both null and undefined but it will fail in jslint validation.
        return val;
    }/*

    let  args=loadArgs(arguments),i=0;
    // console.log(args);
    while(i<args.length-1 && (args[i]==undefined || args[i]==null || isNaN(args[i])|| args[i]=='')){
        i++;
    }
    return args[i];*/
    }
function alt_0(){
    let  args = loadArgs(arguments), i = 0;
    while(i < args.length && (args[i] == undefined || args[i] == null || isNaN(args[i]) || args[i] == '' || args[i] == 0)){
        i++;
    }
    return args[i];
    }
function pgcd(argument) {
    let args = loadArgs(arguments).flat().filterInt();
    if(args.length == 1){
        return args[0];
    }
    let x = Math.abs(args[0]), y = pgcd(args.slice(1));
    while(y) {
        var t = y;
        y = x % y;
        x = t;
    }
    return x;
    }
function ppcm() {
    let args = loadArgs(arguments).filterInt(), decomposes, res = 1;
    decomposes = args.map(el => Number(el).decompose()).flat();
    res = decomposes.filter(elt=>{
        return elt.p == decomposes.filter(elem => elem.num == elt.num).map(elem => elem.p).max();
    }).map(elt => Math.pow(elt.num, elt.p)).filter((v, i, a) => a.indexOf(v) === i).reduce((a, b) => a * b, 1);
    return res;
    }
function rn(val1, val2, precision = 0){
    let min = Math.min(val1,val2), max = Math.max(val1, val2);
    if(precision == 0){
        return parseInt(Math.random() * (max - min) + min);
    }
    return parseFloat(Math.random() * (max - min) + min).toFixed(precision);
    }
function table(options) {
    let obj, rows = [], tr, header, body, table, title = '';
    for (obj of options.headers) {
        rows.push(tag('th', obj, {class: '', scope: 'col'}));
    }
    tr = tag('tr', rows.join(' '));
    header = tag('thead', tr, {class: 'head-table'});
    rows = [];
    for (obj of options.rows) {
        let row = [];
        let datas_row = "";
        for (const col in obj) {
            row.push(tag('td',obj[col]));
            datas_row += "&" + obj[col] + "&";
        }
        rows.push(tag('tr', row.join(''), {
            ':class':"[\"line\",{good:(truth||fail)&&\"" +  datas_row + "\".includes(\"&\"+solution+\"&\"), fail:\"" + datas_row + "\".includes(\"&\"+submited+\"&\")&&fail}]"}));
    }
    body = tag('tbody',rows.join(''));
    if(options.hasOwnProperty('title')){
        title = tag('div', options.title, {class: 'table-tilte'});
    }
    table = tag('table', header + body, Object.assign(options.table_attributes));
    return tag('div', title + table, Object.assign(options.table_attributes));
    }
function tag(tag, html, attributes = {}){
    let tag_name = "<" + tag;
    for (let obj in attributes) {
        tag_name += ` ${obj}="${attributes[obj]}"`;
        // tag_name += " " + obj + "='" + attributes[obj] + "'";
    }
    tag_name += `>${html}</${tag}>`;
    // tag_name += ">"+html+"</"+tag+">";
    return tag_name;
    }
function load_settings(type, number, index =-1, min_in = 0, max_in = 20){
    let num = number.count || number, tab = [],
    number1 = (number instanceof Object) ? '' : '__num1____num2__',
    min = number.min || '__number1__-3',
    max = number.max || '__number1__+3',
    v = [
    {varName: "index", type: "int", constraints: "bt:" + min_in + "||" + max_in},
    {varName: "num1", type: "int", constraints: "bt:1||9"},
    {varName: "num2", type: "int", constraints: "bt:3||7"},
    {varName: 'count', constraints: 'in:' + num}
    ];
    for(let i = 0; i < num; i++){
        tab.push(i + 1);
        v.push(
        {
            varName: type + (i + 1),
            type: type,
            diff: v.map(el => '__' + el.varName + '__').join('||'),
            constraints: index ? ('index:__index__+' + i) : undefined,
        },
        {
            varName: 'number' + (i + 1),
            type: 'int',
            constraints: i == 0 && !(number instanceof Object) ? '__num1____num2__' : 'bt:' + min + '||' + max,
            diff:tab.slice(0, -1).map((el) => '__number' + el + '__').join('||'),
        }
        );
    }
    return {v: v, tab: tab,}
    }
function focus(id) {
    let elem = document.getElementById(id);
    if(elem){
        elem.focus();
    }
    }
function read_notation(nbre){
    if(nbre % 1 > 0){
        return read_notation(nbre.toString().split('.')[0]) + "." + (nbre.toString().split(".")[1]);
    }
    if(nbre > 1000){
        return read_notation(parseInt(nbre / 1000)) + ',' + ('000' + nbre % 1000).slice(-3);
    }else{
        return nbre.toString();
    }
    }
function factors(nbre){
    let res = [];
    for(let i = 2; i <= nbre / 2; i++){
        if(nbre % i == 0){
            res.push(i);
        }
    }
    res.push(nbre);
    return res;
    }
function fixed(nbre1,operds) {
    let operands = operds.filter(Number), decs = operands.map(el => (el.toString().split('.')[1] || '').length);
    if(Math.max(...decs) == 0){
        return parseInt(nbre1);
    }else{
        return parseFloat(nbre1).toFixed(Math.max(...decs) == 0);
    }
    }
function only_except(tab, find){
    return tab.filter(el => {
        if(el.hasOwnProperty('only')){
            return el.only.includes(find);
        }else if(el.hasOwnProperty('except')){
            return !el.except.includes(find);
        }
        return true;
    });
    }
function isValidOnlyExcept(obj = {}, find){
    if(obj.hasOwnProperty('only')){
        return obj.only.includes(find);
    }else if(obj.hasOwnProperty('except')){
        return !obj.except.includes(find);
    }
    return true;
    }
function is_fraction(val){
    if(typeof val === 'object'){
        if(val.is_fraction){
            return true;
        }
        if(val.hasOwnProperty('num') && val.hasOwnProperty('den')){
            return true;
        }
    }else{
        if(typeof val == 'string'){
            let parts = val.split('/');
            if(parts.length <= 1 || parts.length > 2 || Number(parts[1]) === 0){
                return false
            }else return true;
        }
    }
    }
function count_occ(str,sbtr){
    let reg = new RegExp(sbtr, 'g');
    return (str.match(reg) || []).length;
    }
function check_brackets(tab){
    let res = tab.map((el, i) => {
        return count_occ(el, '(') + i === count_occ(el, ')');
    });
    }
function strip_tags(str){
        // Remove all html tags from a string
        let div = document.createElement("div");
        div.innerHTML = str;
        return div.textContent || div.innerText || "";
        }




const Fnc = {
    txt_danger(txt){return "<span class='text-danger'>" + txt + "</span>";},
    copy_arr(arr){return copy_arr(copy_arr(arr));},
    loadArgs($arguments){return loadArgs($arguments);},
    loadArgNumbers($arguments){return loadArgNumbers($arguments);},
    breakExp(html) {return "<br><div class='ml-4'>"+html+"</div>";},
    eraseCookie(name) {document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';},
    addDaysToDate (date, n) {
        const d = new Date(date);
        d.setDate(d.getDate() + n);
        return d.toISOString().split('T')[0];
    },
    alt () {return alt(...arguments);},
    alt_0 () {return alt_0(...arguments);},
    array_group_by (arr, field, children_label="children", options = {}) {
        if(arr instanceof Array) return arr.groupBy(field, children_label, options);
        else {
            this.log_error('Invalid parameter for function array_group_by. Expected: Array but found:', arr.constructor.name, 'arr:', arr);
            return [];
        }
    },
    dayMonth (day) {
        switch (Number(day)) {
            case 0: return 'start'; break;
            case 1: return '1<sup>st</sup>'; break;
            case 2: return '2<sup>nd</sup>'; break;
            case 3: return '3<sup>rd</sup>'; break;
            default: return day + '<sup>th</sup>'; break;
            }
        },
    isImage(filename) {
        var ext = getExtension(filename);
        switch (ext.toLowerCase()) {
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'png':
        return true;
        break;
        }
        return false;
        },
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
        },
    get_rand_array : arr => {if(arr instanceof Array) return arr.getRand(); },
    k_notation : nbre => {return Number(nbre).k_notation},
    load_image(img_, id, width = 150, height){
            let img = new Image(width, height || width),
            div = document.getElementById(id);
            img.src = img_.src;
            img.className = 'avatar';
        if(div !== null){
            div.innerHTML = "";
            div.appendChild(img);
        }
    },
    loadFileFromInput(ev, type = 'Image'){
        let files = ev.target.files||ev.dataTransfer.files, file = files[0];
        if (!file) {
            return Promise.reject('no files found');
        }
        let g = ev.target.getAttribute("accept"),
            accepted = false,
            valid = true,
            errors = {mimeType: false, maxSize: false, width: false, minWidth: false, maxWidth: false, height: false, minHeight: false, maxHeight: false};

        if (g) {
            var h = g.split(/[,|]/), c;
            for (c in h) {
                c = $.trim(c);
                if(file.type === c){
                    accepted = true;
                    return Promise.reject('error on data type')
                }
                if(c.indexOf("/*") !== false){
                    var a = c.replace("/*",""), b = file.type.replace(/(\/.*)$/g,"");
                    if(a === b){
                        accepted = true;
                        return Promise.reject('invalid file extension')
                    }
                }
            }
            if(accepted === false){
                errors.mimeType = true
            }
        } else {
            accepted = true
        }
        var reader = new FileReader(file);

        if (type == 'Image') {
            return new Promise((resolve, reject) => {
                reader.readAsDataURL(file);
                reader.onload = function(e){
                    var image = new Image(), isImage;
                    file.data = e.target.result;
                    image.src = file.data;
                    resolve(image);
                }
                reader.onerror = reject;

            });
        } else {
            return Promise.resolve(j);
        }
        },
    pgcd(){return pgcd(...arguments); },
    ppcm(){return ppcm(...arguments);},
    rn(){return rn(...arguments)},
    setCookie(name, value, expire = 24 * 60 * 60 * 1000, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + expires/* date.toUTCString()*/;
        }
        let cookie = `${name}=${value||''}; path=/; expires=${expire}`;
        log("setting cookie with name:", name, "value:", value, "expire:", expire, "cookie:", cookie);
        document.cookie = cookie;
        },
    table(){return table(...arguments);},
    tag(t,html,attributes){return tag(...arguments);},
    read_notation(){return read_notation(...arguments);},
    factors(){return factors(...arguments);},
    fixed(){return fixed(...arguments);},
    only_except(){return only_except(...arguments);},
    isValidOnlyExcept(){return isValidOnlyExcept(...arguments);},
    is_fraction(){return is_fraction(...arguments);},
    count_occ(){return count_occ(...arguments);},
    check_brackets(){return check_brackets(...arguments);},
    strip_tags(){return strip_tags(...arguments);},
    initiateObjectFromArgument (arg, defaultProperty = 'title') {
        let object = {};
        object[defaultProperty] = defaultProperty == 'id' ? 0 : '';
        switch (typeof arg) {
            case 'string':
                object[defaultProperty] = defaultProperty == 'id' ? (Number(arg) || 0) :  arg;
                break;
            case 'object':
                object = Object.assign(object, arg);
                break;
            case 'number':
                object[defaultProperty] = defaultProperty == 'id' ? arg : defaultProperty + ' ' + arg;
                break;
            default:
                break;
        }
        return object;
    },
    log_error () {
        if (config.debug) {
            console.warn(...arguments);
        }
    },
    log () {
        if (config.debug) {
            console.log(...arguments);
        }
    },
    log_fetched () {
        console.log(...arguments);
    },
    loadVueComponents(files) {
        let components = {};

        for (let key of files.keys()) {
            let name = key.replace(/(\/template\.vue)|\.vue/, '').replace(/\.*/g, '').replace(/\//g, '');
            // components[name] = AsyncComponent(key);

            let file = files(key).default;
            if (file != null && file.hasOwnProperty('name') && !components.hasOwnProperty(file.name)) {
                name = file.name;
            }
            components[name] = file;
        }
        return components;
    },
    reduceToInitial(str) {
        return str.replace(/ (of|for|a) /gi, '').trim().split(' ').map(el => el[0].toUpperCase()).join('').slice(0, 7).replace('WP', ' WP');
    },
    json: {
        isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        replacer: function(match, pIndent, pKey, pVal, pEnd) {
            var key = '<span class=json-key>';
            var val = '<span class=json-value>';
            var str = '<span class=json-string>';
            var r = pIndent || '';
            if (pKey) {
                r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
            }
            if (pVal) {
               r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
            }
           return r + (pEnd || '');
        },
        prettyPrint: function(obj) {
            var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
            return JSON.stringify(obj, null, 3)
                .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
                .replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(jsonLine, this.replacer);
        }
    }
}

export default Fnc;